    import draggable from "vuedraggable";
	
	let idGlobal = 8;

	export default {
		data() {
			return {
				display: "Clone on Control",
				instruction: "Press Ctrl to clone element from list 1",
				order: 4,
				idForList: 4,
				controlOnStart: true,
			}
		},

		methods: {
			clone({ name }) {

				return { name, id: idGlobal++ };

			},
			pullFunction() {
				return this.controlOnStart ? "clone" : true;

			},
			start({ originalEvent }) {
				this.controlOnStart = originalEvent.ctrlKey;
			},
		},
		components: {
            draggable,
		}
	}


// WEBPACK FOOTER //
// ./src/mixins/sortable.js